import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=055112ca&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=ts&"
export * from "./Post.vue?vue&type=script&lang=ts&"
import style0 from "./Post.vue?vue&type=style&index=0&id=055112ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055112ca",
  null
  
)

export default component.exports